export class Product {
    _id: String;
    name: String;
    sapItemCode: String;
    licenseAgreementType: String;
    secondaryLicenseType: String;
    endCustomerType: String;
    material: String;

    constructor(product?) {
        if (product)
            this.populate(product)
    }

    public populate(product) {
        this._id = product._id;
        this.name = product.name;
        this.sapItemCode = product.sapItemCode;
    }

    loadToEdit(r: any){
        if (r._id)
           this._id = r._id;

        if (r.name)
           this.name = r.name;

        if (r.sapItemCode)
            this.sapItemCode = r.sapItemCode;

        if (r.licenseAgreementType)
           this.licenseAgreementType = r.licenseAgreementType;

        if (r.secondaryLicenseType)
            this.secondaryLicenseType = r.secondaryLicenseType;

        if (r.endCustomerType)
            this.endCustomerType = r.endCustomerType;

        if (r.material)
            this.material = r.material;
    }

    loadSearch(r: any){
        if(r._id === undefined)
            return null;
        this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.sapItemCode)
            this.sapItemCode = r.sapItemCode;

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Product.model.ts